import BaseModal from './base/BaseModal';
import React from 'react';
import styles from './ExportVideoModal.module.css'
import I18N from '../classes/I18N'
import translations from '../lang/components/ExportVideoModal.lang.json'

const i18n = new I18N(translations);

class ExportVideoModal extends React.Component {
    render() {
        let {onClose} = this.props
        return (
            <BaseModal
                cssClass={styles.exportVideoModal}
                show={this.props.show}
                hasHeader={false}
                hasFooter={false}
                onClose={onClose}
            >
                <div className={styles.exportingVideoContainer}>
                    <img className={styles.generatingVideoIcon} src="../processing.svg" alt={i18n.t(this.props.locale, 'generatingVideoIconAlt')} />
                    <span className={styles.generatingVideoTitle}>{i18n.t(this.props.locale, 'processingTitle')}</span>
                    <span className={styles.generatingVideoSubtitle}>{i18n.t(this.props.locale, 'processingSubtitle')}</span>
                    <div className={styles.buttonContainer}>
                        <button onClick={onClose}>{i18n.t(this.props.locale, 'close')}</button>
                    </div>
                </div>
            </BaseModal>
        )
    }
}

ExportVideoModal.defaultProps = {
    onClose: () => {}
}

export default ExportVideoModal;
